// У Solar нет ГОЛЫХ галочки, крестика, плюса и минуса — только в круге или квадрате.
// А у нас Check стоит 9 раз и X 12 раз на 10–18px, где кольцо вокруг глифа
// схлопывается в кашу. Поэтому эти два примитива нарисованы вручную в геометрии
// Solar: сетка 24, оптический квадрат ~2..22, обводка 2, круглые торцы и стыки.
// Всё остальное берётся из ./solar — сюда добавлять глифы, которых в паке нет.

import type { IconComponent } from './types'

// Refresh: стрелки из solar `refresh-circle-linear` БЕЗ окружающего кольца.
// Внутри кольца они занимали 12×10 из 24 (половину поля) и на 11–14px, где эта
// иконка и стоит, распадались. Масштаб ровно 20/12 и сдвиг −8 растягивают их до
// 20 из 24 по центру; обводка 1.2 × 1.6667 даёт на экране те же 2, что и у всего
// остального пака, — растёт глиф, а не вес.
const REFRESH_SCALE = 20 / 12

export const Refresh: IconComponent = ({ size = 24, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    focusable="false"
    {...rest}
  >
    <g
      transform={`translate(-8 -8) scale(${REFRESH_SCALE})`}
      fill="none"
      stroke="currentColor"
      strokeWidth={2 / REFRESH_SCALE}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M7.37756 12.5556L7.37756 11.6296C7.37756 9.07276 9.46667 7 12.0437 7C13.4045 7 14.6293 7.57797 15.4822 8.5M6 11L7.37756 12.5556L9 11" />
      <path d="M16.6188 11.4443V12.3703C16.6188 14.9271 14.5217 16.9999 11.9348 16.9999C10.5777 16.9999 9.35544 16.4295 8.5 15.518M18 12.999L16.6188 11.4443L15 12.999" />
    </g>
  </svg>
)

export const Check: IconComponent = ({ size = 24, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    focusable="false"
    {...rest}
  >
    <path
      d="M5 12.5L9.5 17L19 7"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const EyeClosed: IconComponent = ({ size = 24, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    focusable="false"
    {...rest}
  >
    <g fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <path d="M3.27 15.3C2.42 14.19 2 13.64 2 12s.43-2.19 1.27-3.3C4.97 6.5 7.82 4 12 4c4.18 0 7.03 2.5 8.73 4.7C21.58 9.81 22 10.36 22 12" />
      <path d="M9 11.5 8 15.5M15 11.5 16 15.5M12 11.5V16" />
    </g>
  </svg>
)

export const X: IconComponent = ({ size = 24, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    focusable="false"
    {...rest}
  >
    <path
      d="M6.5 6.5L17.5 17.5M17.5 6.5L6.5 17.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
